export default __webpack_public_path__ + "static/media/tagme.5627f8b2.png";